"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 2a.99.99 0 00-.96.73l-2.99 9.96A1.003 1.003 0 007 14c.46 0 .85-.31.96-.73l2.99-9.96A1.003 1.003 0 0010 2z"];
//# sourceMappingURL=slash.js.map